<template>
<div>
  <div class="contact-info">
    <img class="logo" src="@/assets/img/contact-logo.png" :alt="info.caseName" />
    <div class="info">
      <div class="btn flex-c" @click="showCallDialog">
        <span class="flex-c">
          <font-awesome-icon icon="phone" />
          <span>{{info.phone}}</span>
        </span>
      </div>
      <div class="btn flex-c" @click="showMessengerDialog">
        <span class="flex-c">
          <font-awesome-icon :icon="['fab', 'facebook-messenger']" /><span>FB 諮詢</span>
        </span>
      </div>
      <a class="btn flex-c" :href="info.fbLink" target="_blank" @click="window.gtag_report_conversion_fb(info.fbLink)">
        <span class="flex-c">
          <font-awesome-icon :icon="['fab', 'facebook-f']" /><span>前往粉絲專頁</span>
        </span>
      </a>
      <div class="address flex-c">{{info.address}}</div>
      <div class="btn flex-c" @click="showMapDialog">
        <span class="flex-c">
          <font-awesome-icon icon="map-marker-alt" /><span>導航 Google 地圖</span>
        </span>
      </div>
    </div>
    <div class="logos">
      <img src="data:image/svg+xml,%0A%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 180 20' %3E%3ClinearGradient id='ID_1_' gradientUnits='userSpaceOnUse' x1='321' y1='-9.1e-13' x2='321' y2='9.6'%3E%3Cstop offset='0' style='stop-color:%237B2702'/%3E%3Cstop offset='1' style='stop-color:%23E62C17'/%3E%3C/linearGradient%3E%3Cpath fill='url(%23ID_1_)' d='M8.2,9.6v-4l8.8-5.3c0,0,0.7-0.4,1.6,0c0.7,0.4,2.7,1.7,2.7,1.7L8.2,9.6z'/%3E%3ClinearGradient id='ID_2_' gradientUnits='userSpaceOnUse' x1='-3536' y1='9.6' x2='-3536' y2='0'%3E%3Cstop offset='0' style='stop-color:%23F5A719'/%3E%3Cstop offset='1' style='stop-color:%23ED7300'/%3E%3C/linearGradient%3E%3Cpath fill='url(%23ID_2_)' d='M27.3,9.6v-4l-8.8-5.3c0,0-0.7-0.4-1.6,0c-0.7,0.4-2.7,1.7-2.7,1.7L27.3,9.6z'/%3E%3Cpolygon fill='%23941F24' points='8.2,10.1 8.2,10.3 18.3,4.3 18.1,4.2 '/%3E%3Cpath fill='%23fff' d='M113.9,12.7v1h-7.9v-1h3.1V6.1h1.1v2.5h3.1v1.1h-3.1v3H113.9z M117.4,10.7c-0.3,0.1-0.5,0.1-0.8,0.2V13 c0,0.5-0.1,0.8-0.4,1c-0.3,0.2-0.7,0.2-1.3,0.2c0-0.3-0.2-0.7-0.3-1c0.3,0,0.7,0,0.8,0c0.1,0,0.1,0,0.1-0.2v-1.8l-1,0.3l-0.2-1 c0.3-0.1,0.7-0.2,1.2-0.3V8.6h-1v-1h1V6h1v1.6h0.7v1h-0.7V10l0.7-0.2L117.4,10.7z M119.3,10.4c-0.1,0.1-0.2,0.3-0.3,0.4h3.4 c0,0,0,0.2,0,0.4c-0.1,1.7-0.2,2.4-0.4,2.6c-0.2,0.2-0.3,0.3-0.6,0.3c-0.2,0-0.6,0-0.9,0c0-0.3-0.1-0.6-0.3-0.9c0.3,0,0.6,0,0.7,0 c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.6,0.3-1.6h-0.3c-0.4,1-1,1.9-1.7,2.5c-0.1-0.1-0.5-0.4-0.7-0.5c0.6-0.5,1.2-1.2,1.5-2h-0.4 c-0.5,0.9-1.3,1.8-2.1,2.3c-0.1-0.1-0.5-0.5-0.6-0.6c0.7-0.4,1.4-1,1.8-1.7h-0.4c-0.3,0.3-0.6,0.6-0.8,0.8c-0.1-0.2-0.5-0.4-0.7-0.6 c0.6-0.4,1-0.9,1.4-1.5h-0.9V9.6h5.3v0.8H119.3z M122.1,9.2H118V6.3h4.1V9.2z M121.1,7H119v0.4h2.2V7z M121.1,8.1H119v0.4h2.2V8.1z M131.1,6.4v7.8h-1v-0.4h-5.4v0.4h-1V6.4H131.1z M130.1,12.9V7.3H129c0.3,0.1,0.6,0.3,0.7,0.5l-0.3,0.4h0.4v0.7h-1.6 c0,0.5,0.1,0.9,0.2,1.3c0.2-0.3,0.3-0.7,0.4-1.1l0.8,0.2c-0.2,0.8-0.5,1.4-0.9,2c0.1,0.3,0.2,0.4,0.4,0.5c0.1,0,0.2-0.3,0.2-0.8 c0.2,0.2,0.5,0.4,0.6,0.5c-0.1,1.1-0.6,1.4-1.2,1.1c-0.3-0.1-0.5-0.3-0.7-0.6c-0.3,0.3-0.6,0.5-0.9,0.7c-0.1-0.2-0.4-0.5-0.6-0.6 c0.1-0.1,0.2-0.1,0.3-0.2c-0.7,0.1-1.4,0.2-2,0.3l-0.1-0.8c0.6-0.1,1.5-0.2,2.5-0.3l0,0.4c0.2-0.1,0.3-0.3,0.4-0.4 c-0.2-0.6-0.3-1.4-0.4-2.3H125V8.2h2.4c0-0.2,0-0.5,0-0.7h0.9c0,0.3,0,0.5,0,0.7h0.9c-0.2-0.2-0.4-0.3-0.7-0.5l0.4-0.4h-4.2v5.6 H130.1z M127.1,11h-1.9V9.3h1.9V11z M126.4,9.9h-0.6v0.6h0.6V9.9z M136.1,9.8c-0.3,0.3-0.6,0.6-0.9,0.8c-0.1-0.2-0.3-0.5-0.5-0.6 c0.1,0.3,0.1,0.6,0.1,0.8c0,0.6-0.1,0.9-0.4,1.1c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.3,0-0.5,0c0-0.2-0.1-0.6-0.2-0.9 c0.1,0,0.3,0,0.3,0c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.3,0.1-0.5c0-0.4-0.1-1-0.6-1.6c0.2-0.5,0.3-1.2,0.5-1.8h-0.6v6.9h-0.9V6.4 h1.8l0.1,0l0.6,0.4c-0.1,0.4-0.2,0.8-0.3,1.1c0.5-0.5,0.8-1.1,1.1-1.8l0.8,0.2c-0.1,0.1-0.1,0.3-0.2,0.4h0.7l0.1,0l0.5,0.2l0,0.2 l0.4-0.1l0-0.4h1.4l0.2,0l0.6,0.3c-0.2,0.7-0.6,1.5-1,2c0.3,0.5,0.8,0.9,1.2,1.1c-0.2,0.2-0.5,0.5-0.6,0.7c-0.4-0.2-0.7-0.6-1-0.9 v0.5h-2.6V9.8z M135.8,8.9c0.1-0.1,0.2-0.3,0.3-0.4c-0.2-0.2-0.4-0.4-0.6-0.5c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1-0.1-0.3-0.3-0.5-0.4 c-0.1,0.3-0.2,0.6-0.3,0.8c0.2,0.3,0.4,0.7,0.5,1c0.3-0.2,0.6-0.5,0.9-0.8c-0.3,0.1-0.6,0.1-1,0.2l-0.1-0.6c0.4,0,0.7-0.1,1.2-0.1 L135.8,8.9z M136.5,12.3c-0.3,0.5-0.8,1.2-1.2,1.6c-0.2-0.2-0.6-0.4-0.8-0.5c0.4-0.4,0.8-0.9,1.1-1.4L136.5,12.3z M137.9,11.7v2.5 h-1v-2.5h-1.6v-0.8h4.2v0.8H137.9z M136,7.3l-0.1,0.1c0.2,0.1,0.4,0.3,0.6,0.4c0.1-0.2,0.1-0.3,0.2-0.5H136z M138.5,9.4 c-0.4-0.6-0.7-1.3-1-2.1c-0.2,0.8-0.6,1.5-1,2.1H138.5z M138.3,7.2c0.1,0.3,0.2,0.6,0.3,0.8c0.2-0.3,0.3-0.6,0.4-0.8H138.3z M139.1,11.9c0.4,0.4,0.9,1,1.2,1.4l-0.8,0.5c-0.2-0.4-0.8-1-1.1-1.5L139.1,11.9z M148.9,8.5v0.7h-1.6l-0.1,0.7h-5l0.1-0.7h-1.4V8.5 h1.5l0.1-0.7h4.9l-0.1,0.7H148.9z M146.6,13c0.8,0.2,1.5,0.4,2.1,0.6l-0.7,0.6c-0.6-0.2-1.7-0.6-2.7-0.8l0.4-0.4H144l0.5,0.4 c-0.7,0.4-2,0.7-3,0.9c-0.1-0.2-0.4-0.5-0.6-0.7c0.8-0.1,1.7-0.3,2.3-0.5H142v-2.8h5.7V13H146.6z M142.1,8.3h-0.9V6.7h3.2 c-0.1-0.2-0.2-0.4-0.3-0.5L145,6c0.1,0.2,0.3,0.5,0.4,0.8h3.2v1.5h-1V7.5h-5.5V8.3z M143.1,10.9h3.6v-0.3h-3.6V10.9z M143.1,11.7 h3.6v-0.3h-3.6V11.7z M143.1,12.5h3.6v-0.3h-3.6V12.5z M143.2,9.4h1.2l0-0.3h-1.2L143.2,9.4z M143.3,8.3l0,0.3h1.1l0-0.3H143.3z M146.3,9.4l0-0.3h-1.1l0,0.3H146.3z M146.4,8.3h-1.1l0,0.3h1.1L146.4,8.3z M152.9,12.8c-0.6,0.5-1.6,1-2.5,1.2 c-0.1-0.2-0.4-0.6-0.6-0.8c0.9-0.1,1.9-0.4,2.4-0.7L152.9,12.8z M157.5,11.4v0.9h-3.4v2h-1v-2h-3.3v-0.9h3.3V11h-2.5v-0.8h2.5V9.8 h-3V9h1.6c-0.1-0.2-0.2-0.4-0.3-0.6l0.6-0.1h-2.2V7.5h1.2c-0.1-0.3-0.4-0.8-0.6-1.1l0.9-0.3c0.3,0.4,0.6,0.9,0.7,1.2l-0.4,0.2h0.8V6 h1v1.4h0.7V6h1v1.4h0.8l-0.3-0.1c0.2-0.3,0.4-0.9,0.6-1.3l1.1,0.3c-0.2,0.4-0.5,0.8-0.7,1.1h1.1v0.8h-2.3l0.8,0.2 c-0.2,0.2-0.4,0.4-0.5,0.6h1.7v0.8h-3v0.4h2.6V11h-2.6v0.4H157.5z M152.5,8.3c0.1,0.2,0.3,0.5,0.3,0.7L152.3,9h2.4l-0.3-0.1 c0.1-0.2,0.3-0.5,0.4-0.7H152.5z M155.2,12.4c0.7,0.3,1.7,0.7,2.3,1l-0.7,0.6c-0.5-0.3-1.5-0.8-2.3-1.1L155.2,12.4z M158.7,10.7 c0-1.7,0.5-3.2,1.3-4.5l0.8,0.3c-0.7,1.3-1.1,2.8-1.1,4.2c0,1.4,0.3,2.9,1.1,4.2l-0.8,0.3C159.2,13.8,158.7,12.4,158.7,10.7z M169.5,10c-0.3,1.1-0.8,2-1.5,2.6c0.5,0.3,1.1,0.5,1.7,0.6c-0.2,0.2-0.5,0.6-0.7,0.9c-0.7-0.2-1.3-0.5-1.9-0.9 c-0.6,0.4-1.2,0.6-1.9,0.8c-0.1-0.3-0.3-0.6-0.5-0.9c0,0.3-0.1,0.5-0.3,0.6c-0.2,0.2-0.6,0.2-1.1,0.2c0-0.3-0.1-0.7-0.3-1 c0.3,0,0.5,0,0.6,0c0.1,0,0.1,0,0.1-0.1v-1.7c-0.2,0.1-0.5,0.3-0.7,0.4l-0.3-0.6c-0.1,1.1-0.2,2.3-0.5,3.1c-0.2-0.2-0.6-0.4-0.8-0.5 c0.5-1.2,0.5-2.9,0.5-4.2V6.3h2.8v2.6c0.9-0.5,1.1-1.1,1.1-1.7V6.3h2.9v1.9c0,0.3,0,0.3,0.1,0.3h0.3c0.1,0,0.3,0,0.4-0.1 c0,0.3,0,0.6,0.1,0.8c-0.1,0-0.3,0.1-0.5,0.1h-0.4c-0.8,0-1-0.3-1-1.2V7.3h-1v0c0,0.8-0.3,1.8-1.4,2.4c-0.1-0.2-0.4-0.5-0.6-0.6v4 c0,0.1,0,0.1,0,0.2c0.6-0.1,1.1-0.3,1.6-0.6c-0.5-0.5-0.8-1.1-1.1-1.7l0.4-0.1h-0.6v-1h3.6l0.2,0L169.5,10z M163,9.5 c0,0.4,0,0.8,0,1.2c0.3-0.1,0.6-0.2,0.9-0.3v-1l-0.3,0.3c-0.1-0.2-0.3-0.4-0.5-0.7V9.5z M163,7.3v1.1l0.2-0.2 c0.2,0.2,0.4,0.4,0.6,0.7V7.3H163z M166.3,10.8c0.2,0.5,0.6,0.9,1,1.2c0.4-0.3,0.7-0.8,0.9-1.2H166.3z M170.5,14.9 c0.7-1.3,1.1-2.7,1.1-4.2c0-1.4-0.3-2.9-1.1-4.2l0.8-0.3c0.8,1.3,1.3,2.8,1.3,4.5c0,1.8-0.5,3.2-1.3,4.5L170.5,14.9z M102.8,2.4 h-0.5v15.3h0.5V2.4z M14.7,11.7l0.3-0.1c0.1,0.2,0.2,0.3,0.5,0.3c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.3c0,0,0-0.1,0-0.1 c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.2-0.1-0.4-0.2-0.5-0.3 c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.2,0.3l-0.3,0.2 c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0,0,0,0 c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0.1,0.2,0.1,0.4c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.6,0.2c-0.2,0-0.4,0-0.5-0.1 C14.8,12,14.8,11.9,14.7,11.7z M16.6,9.9H17v1.4c0,0.4,0.2,0.6,0.6,0.6c0.4,0,0.6-0.2,0.6-0.6V9.9h0.4v1.5c0,0.6-0.3,0.9-1,0.9 c-0.6,0-1-0.3-1-0.9V9.9z M19.1,12.2V9.8l1.5,1.4c0.1,0.1,0.2,0.2,0.3,0.3V9.9h0.3v2.4l-1.5-1.5c-0.1-0.1-0.2-0.2-0.2-0.3v1.6H19.1z M12.6,15.7v-1.1l-0.8-1.3h0.4l0.5,0.8c0,0,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2l0.5-0.8h0.4L13,14.6v1.1H12.6z M16.3,14.5 c0,0.3-0.1,0.6-0.4,0.9c-0.2,0.2-0.5,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.9-0.4c-0.2-0.2-0.4-0.5-0.4-0.9c0-0.3,0.1-0.6,0.4-0.9 c0.2-0.2,0.5-0.4,0.9-0.4c0.3,0,0.6,0.1,0.9,0.4C16.2,13.9,16.3,14.2,16.3,14.5z M15.9,14.5c0-0.2-0.1-0.4-0.3-0.6 c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.3,0.6,0.3 c0.2,0,0.4-0.1,0.6-0.3C15.9,15,15.9,14.8,15.9,14.5z M16.8,13.4h0.4v1.4c0,0.4,0.2,0.6,0.6,0.6c0.4,0,0.6-0.2,0.6-0.6v-1.4h0.4v1.5 c0,0.6-0.3,0.9-1,0.9c-0.6,0-1-0.3-1-0.9V13.4z M19.2,15.7v-2.4l1.5,1.4c0.1,0.1,0.2,0.2,0.3,0.3v-1.6h0.3v2.4l-1.5-1.5 c-0.1-0.1-0.2-0.2-0.2-0.3v1.6H19.2z M23.1,14.5H24c0,0.1,0,0.2,0,0.2c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.3-0.8,0.3 c-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.2-0.3-0.5-0.3-0.9c0-0.4,0.1-0.7,0.4-0.9c0.2-0.2,0.5-0.3,0.9-0.3c0.4,0,0.7,0.1,0.9,0.4l-0.3,0.2 c-0.2-0.2-0.4-0.3-0.6-0.3c-0.3,0-0.5,0.1-0.6,0.2c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.3,0.1,0.5,0.2,0.6c0.2,0.2,0.4,0.2,0.6,0.2 c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.2,0.2-0.4v0h-0.6V14.5z M37.8,12.7v1h-7.9v-1H33V6.1h1.1v2.5h3.1v1.1h-3.1v3H37.8z M41.4,10.7 c-0.3,0.1-0.5,0.1-0.8,0.2V13c0,0.5-0.1,0.8-0.4,1c-0.3,0.2-0.7,0.2-1.3,0.2c0-0.3-0.2-0.7-0.3-1c0.3,0,0.7,0,0.8,0 c0.1,0,0.1,0,0.1-0.2v-1.8l-1,0.3l-0.2-1c0.3-0.1,0.7-0.2,1.2-0.3V8.6h-1v-1h1V6h1v1.6h0.7v1h-0.7V10l0.7-0.2L41.4,10.7z M43.3,10.4 c-0.1,0.1-0.2,0.3-0.3,0.4h3.4c0,0,0,0.2,0,0.4c-0.1,1.7-0.2,2.4-0.4,2.6c-0.2,0.2-0.3,0.3-0.6,0.3c-0.2,0-0.6,0-0.9,0 c0-0.3-0.1-0.6-0.3-0.9c0.3,0,0.6,0,0.7,0c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.6,0.3-1.6h-0.3c-0.4,1-1,1.9-1.7,2.5 c-0.1-0.1-0.5-0.4-0.7-0.5c0.6-0.5,1.2-1.2,1.5-2h-0.4c-0.5,0.9-1.3,1.8-2.1,2.3c-0.1-0.1-0.5-0.5-0.6-0.6c0.7-0.4,1.4-1,1.8-1.7 h-0.4c-0.3,0.3-0.6,0.6-0.8,0.8c-0.1-0.2-0.5-0.4-0.7-0.6c0.6-0.4,1-0.9,1.4-1.5h-0.9V9.6h5.3v0.8H43.3z M46,9.2H42V6.3H46V9.2z M45.1,7h-2.2v0.4h2.2V7z M45.1,8.1h-2.2v0.4h2.2V8.1z M55,6.4v7.8h-1v-0.4h-5.4v0.4h-1V6.4H55z M54,12.9V7.3h-1.1 c0.3,0.1,0.6,0.3,0.7,0.5l-0.3,0.4h0.4v0.7h-1.6c0,0.5,0.1,0.9,0.2,1.3c0.2-0.3,0.3-0.7,0.4-1.1l0.8,0.2c-0.2,0.8-0.5,1.4-0.9,2 c0.1,0.3,0.2,0.4,0.4,0.5c0.1,0,0.2-0.3,0.2-0.8c0.2,0.2,0.5,0.4,0.6,0.5c-0.1,1.1-0.6,1.4-1.2,1.1c-0.3-0.1-0.5-0.3-0.7-0.6 c-0.3,0.3-0.6,0.5-0.9,0.7c-0.1-0.2-0.4-0.5-0.6-0.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.7,0.1-1.4,0.2-2,0.3l-0.1-0.8 c0.6-0.1,1.5-0.2,2.5-0.3l0,0.4c0.2-0.1,0.3-0.3,0.4-0.4c-0.2-0.6-0.3-1.4-0.4-2.3h-2.4V8.2h2.4c0-0.2,0-0.5,0-0.7h0.9 c0,0.3,0,0.5,0,0.7h0.9c-0.2-0.2-0.4-0.3-0.7-0.5l0.4-0.4h-4.2v5.6H54z M51.1,11h-1.9V9.3h1.9V11z M50.4,9.9h-0.6v0.6h0.6V9.9z M60.1,9.8c-0.3,0.3-0.6,0.6-0.9,0.8c-0.1-0.2-0.3-0.5-0.5-0.6c0.1,0.3,0.1,0.6,0.1,0.8c0,0.6-0.1,0.9-0.4,1.1 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.3,0-0.5,0c0-0.2-0.1-0.6-0.2-0.9c0.1,0,0.3,0,0.3,0c0.1,0,0.2,0,0.2-0.1 c0.1-0.1,0.1-0.3,0.1-0.5c0-0.4-0.1-1-0.6-1.6c0.2-0.5,0.3-1.2,0.5-1.8h-0.6v6.9h-0.9V6.4h1.8l0.1,0l0.6,0.4 c-0.1,0.4-0.2,0.8-0.3,1.1C59,7.4,59.4,6.7,59.6,6l0.8,0.2c-0.1,0.1-0.1,0.3-0.2,0.4h0.7l0.1,0l0.5,0.2l0,0.2l0.4-0.1l0-0.4h1.4 l0.2,0l0.6,0.3c-0.2,0.7-0.6,1.5-1,2c0.3,0.5,0.8,0.9,1.2,1.1c-0.2,0.2-0.5,0.5-0.6,0.7c-0.4-0.2-0.7-0.6-1-0.9v0.5h-2.6V9.8z M59.8,8.9c0.1-0.1,0.2-0.3,0.3-0.4c-0.2-0.2-0.4-0.4-0.6-0.5c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1-0.1-0.3-0.3-0.5-0.4 c-0.1,0.3-0.2,0.6-0.3,0.8c0.2,0.3,0.4,0.7,0.5,1c0.3-0.2,0.6-0.5,0.9-0.8c-0.3,0.1-0.6,0.1-1,0.2l-0.1-0.6c0.4,0,0.7-0.1,1.2-0.1 L59.8,8.9z M60.5,12.3c-0.3,0.5-0.8,1.2-1.2,1.6c-0.2-0.2-0.6-0.4-0.8-0.5c0.4-0.4,0.8-0.9,1.1-1.4L60.5,12.3z M61.9,11.7v2.5h-1 v-2.5h-1.6v-0.8h4.2v0.8H61.9z M59.9,7.3l-0.1,0.1c0.2,0.1,0.4,0.3,0.6,0.4c0.1-0.2,0.1-0.3,0.2-0.5H59.9z M62.4,9.4 c-0.4-0.6-0.7-1.3-1-2.1c-0.2,0.8-0.6,1.5-1,2.1H62.4z M62.2,7.2c0.1,0.3,0.2,0.6,0.3,0.8c0.2-0.3,0.3-0.6,0.4-0.8H62.2z M63,11.9 c0.4,0.4,0.9,1,1.2,1.4l-0.8,0.5c-0.2-0.4-0.8-1-1.1-1.5L63,11.9z M67.5,9.1c-0.1,1.3-0.3,2.3-0.7,3.2c0.8,0.7,1.9,0.8,3.2,0.8 c0.5,0,2.3,0,2.9,0c-0.1,0.2-0.3,0.7-0.4,1H70c-1.5,0-2.7-0.2-3.6-0.9c-0.3,0.5-0.6,0.8-1,1.1c-0.1-0.2-0.5-0.6-0.8-0.7 c0.4-0.3,0.8-0.7,1-1.2c-0.3-0.5-0.6-1-0.8-1.7l0.8-0.3c0.1,0.4,0.3,0.7,0.4,1c0.2-0.4,0.3-1,0.3-1.5h-1.4c0.3-0.6,0.8-1.6,1.2-2.5 h-1.3V6.5h2.7c-0.3,0.8-0.7,1.7-1.1,2.5h0.2l0.2,0L67.5,9.1z M69.3,7.5h-1.5V6.7h1.5V6.1h1v0.7h1.9v1.2h0.5v0.8h-0.5v1.2h-1.9v0.4h2 V11h-2v0.4h2.3v0.8h-2.3v0.6h-1v-0.6h-1.9v-0.8h1.9V11h-1.6v-0.8h1.6V9.8h-1.5V9.1h1.5V8.7h-2V7.9h2V7.5z M70.3,7.5v0.4h1V7.5H70.3z M71.3,8.7h-1v0.4h1V8.7z M81.6,7.3h-1.5c0.2,0.2,0.3,0.4,0.5,0.5l-0.7,0.5h0.6v1.7c0,0.1,0,0.2,0,0.3c0,0,0.1,0,0.1,0h0.1 c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.3,0-0.6c0.2,0.1,0.4,0.3,0.7,0.4c0,0.3-0.1,0.7-0.1,0.8c-0.1,0.1-0.2,0.3-0.3,0.3 c-0.1,0.1-0.3,0.1-0.5,0.1h-0.4c-0.2,0-0.4-0.1-0.6-0.2c-0.1-0.1-0.2-0.3-0.2-0.7l-0.3,0.6c-0.2-0.1-0.4-0.2-0.6-0.3 c-0.1,0.2-0.3,0.3-0.5,0.5h0.1v0.5h3.5v0.8h-2.3c0.7,0.3,1.7,0.8,2.2,1.1L80.7,14c-0.5-0.4-1.5-0.9-2.2-1.2l0.7-0.6h-1.1v2h-1v-2 h-3.4v-0.8H77v-0.5h0.1c-0.1-0.1-0.2-0.2-0.3-0.3v0c-1.1,0.1-2.2,0.3-3,0.4l-0.1-0.8c0.3,0,0.7-0.1,1.2-0.1V9.1h-1.1V8.3h2.2 c-0.2-0.2-0.5-0.6-0.7-0.8l0.3-0.3H75c-0.3,0.4-0.6,0.7-0.9,0.9C74,8,73.7,7.6,73.5,7.5c0.5-0.4,1-0.9,1.3-1.5l0.9,0.3 c0,0.1-0.1,0.2-0.1,0.3h1.9v0.8h-1.3c0.2,0.2,0.4,0.4,0.5,0.6l-0.6,0.5h0.7v0.7h-1v1c0.3,0,0.7-0.1,1-0.1l0,0.7 c0.4-0.2,0.7-0.3,0.8-0.5c-0.2-0.1-0.5-0.2-0.7-0.3l0.4-0.6c0.2,0.1,0.4,0.2,0.6,0.3c0,0,0-0.1,0-0.1V9h-0.8V8.3h2.6 c-0.1-0.2-0.4-0.6-0.7-0.8l0.3-0.2h-0.7c-0.2,0.4-0.5,0.7-0.8,0.9c-0.2-0.2-0.6-0.5-0.8-0.6c0.5-0.4,1-1,1.2-1.6l0.9,0.2 c0,0.1-0.1,0.2-0.1,0.3h2.4L81.6,7.3z M76.7,12.6c-0.5,0.7-1.5,1.3-2.4,1.5c-0.2-0.3-0.5-0.6-0.7-0.9c0.9-0.2,1.8-0.5,2.2-1 L76.7,12.6z M78.8,9.3c0,0.2,0,0.3,0,0.5c0.3,0.1,0.5,0.2,0.6,0.3V10V9h-0.6V9.3z M90,6.3v7.9h-1v-0.4h-5.4v0.4h-0.9V6.3H90z M89,13 V7.1h-5.4V13H89z M88.8,11.7h-1.1v0.6c0,0.3-0.1,0.4-0.3,0.5c-0.2,0.1-0.6,0.1-1.1,0.1c0-0.2-0.1-0.4-0.2-0.5c0.2,0,0.5,0,0.6,0 c0.1,0,0.1,0,0.1-0.1v-0.5h-1.5c0.2,0.2,0.5,0.5,0.6,0.7l-0.7,0.3c-0.1-0.2-0.4-0.6-0.6-0.8l0.6-0.3h-1.4v-0.6h3.1v-0.3h0.9v0.3h0.5 c-0.1-0.1-0.2-0.2-0.3-0.3c-1.4,0.1-2.9,0.1-4,0.1l0-0.6c0.5,0,1.2,0,1.9,0v-0.3h-1.7V8.4h1.7V8.1h-2V7.5h2V7.2h0.8v0.3h2v0.6h-2 v0.3h1.8v1.8H88c0.3,0.2,0.6,0.5,0.7,0.7l-0.5,0.3h0.5V11.7z M84.9,9.1h0.9V8.8h-0.9V9.1z M85.8,9.7V9.5h-0.9v0.3H85.8z M86.7,8.8 v0.3h0.9V8.8H86.7z M87.6,9.5h-0.9v0.3h0.9V9.5z M86.7,10.4h0.7l-0.1-0.1l0.3-0.2h-0.9V10.4z M94,6.8c-0.2,0.7-0.5,1.7-0.8,2.4 c0.5,0.7,0.6,1.3,0.6,1.8c0,0.6-0.1,0.9-0.4,1.1c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4,0-0.6,0c0-0.3-0.1-0.6-0.2-0.9 c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.2-0.1C93,11.2,93,11,93,10.8c0-0.4-0.1-1-0.6-1.5c0.2-0.5,0.3-1.3,0.5-1.9h-0.7v6.9h-0.9V6.4h1.9 l0.1,0L94,6.8z M99,9.3c-0.3,0.2-0.7,0.4-1,0.6c0.3,0.9,0.8,1.9,1.3,2.4c-0.2,0.1-0.5,0.5-0.7,0.7c-0.5-0.6-1.1-1.7-1.4-2.7l0,0 c0.4,1.4,0.2,2.9-0.3,3.3c-0.3,0.3-0.6,0.4-1,0.4c-0.2,0-0.5,0-0.7,0c0-0.3-0.1-0.6-0.2-0.9c0.3,0,0.6,0,0.8,0c0.2,0,0.3,0,0.5-0.2 c0.2-0.2,0.3-0.6,0.3-1.1c-0.6,0.5-1.5,1-2.2,1.2c-0.1-0.2-0.4-0.5-0.6-0.7c1-0.3,2.1-0.9,2.7-1.5c0-0.1-0.1-0.3-0.1-0.5 c-0.5,0.4-1.2,0.8-1.7,1.1c-0.1-0.2-0.3-0.6-0.6-0.7c0.6-0.2,1.5-0.7,2-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.5,0.3-1,0.6-1.4,0.8 c-0.1-0.2-0.4-0.6-0.6-0.7c0.6-0.2,1.3-0.6,1.8-1H94V7.4h1.4c-0.2-0.3-0.5-0.6-0.8-0.9l0.8-0.5c0.4,0.3,0.8,0.7,1,1l-0.4,0.3h0.8 C96.9,7,97.3,6.5,97.5,6l1,0.3c-0.2,0.4-0.5,0.8-0.7,1.1H99v0.9h-2.3c-0.1,0.1-0.2,0.2-0.4,0.3c0.2,0.3,0.4,0.6,0.6,0.9 c0.5-0.3,1.1-0.7,1.4-1L99,9.3z'/%3E%3C/svg%3E%0A" alt="上揚國際">
    </div>
  </div>
  <el-dialog title :visible.sync="isShowCallDialog" :width="isMobile ? '90%' : '500px'" :modal-append-to-body="false">
    <CallDialog :phone="info.phone" />
  </el-dialog>
  <el-dialog
    title
    :visible.sync="isShowMessengerDialog"
    :width="isMobile ? '90%' : '500px'"
    :modal-append-to-body="false"
  >
    <MessengerDialog :messenger="info.fbMessage" />
  </el-dialog>
  <el-dialog title :visible.sync="isShowMapDialog" :width="isMobile ? '90%' : '500px'" :modal-append-to-body="false">
    <MapDialog :link="info.googleLink" :address="info.address" />
  </el-dialog>
  </div>
</template>

<script>
import info from '@/info'
import { isMobile, isTablet } from '@/utils'
import CallDialog from '@/components/Dialog/Call'
import MessengerDialog from '@/components/Dialog/Messenger'
import MapDialog from '@/components/Dialog/Map'
export default {
  name: 'contactInfo',
  components: {
    CallDialog,
    MessengerDialog,
    MapDialog,
  },
  data() {
    return {
      window,
      info,

      isMobile,
      isTablet,
      isShowCallDialog: false,
      isShowMessengerDialog: false,
      isShowMapDialog: false,
    }
  },
  methods: {
    showCallDialog() {
      // if (!this.isMobile) return
      this.isShowCallDialog = true
    },
    showMessengerDialog() {
      // if (!this.isMobile) return
      this.isShowMessengerDialog = true
    },

    showMapDialog() {
      // if (!this.isMobile) return
      this.isShowMapDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/variableColor.scss';
@import '@/assets/style/variableDefault.scss';

.contact-info {
  background: $contact_bg;
  // background-image: url('../assets/img/contact_bg.jpg');/
  background-size: cover;
  //box-shadow: $contact_shadow;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
  position: relative;
  z-index: 3;
  width: 1200px;
  height: 460px;
  /* background-size: 100vw auto;
  background-attachment: fixed;
  background-position: 0% 50%; */
  transform: translateY(0);
  margin: 2vw auto -3vw;
  padding: 70px 0 50px;
}

.logo {
  width: $contact_logo_pc_width;
  height:auto;
 // height:;
  margin: 0 auto 40px;
}

.logos{
  position: absolute;right: 0;bottom: 0;height:30px;
z-index: 20;
img{height: 100%;}}

.info {
  width: 880px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.btn {
  width: 280px;
  height: 60px;
  font-size: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  text-decoration: none;
  color: $contact_btn_color;
  background: $contact_btn_bg;
  // box-shadow: $contact_btn_border;
  transition: all 0.5s;
  position: relative;
  overflow: hidden;
font-weight: 600;
  &.half {
    width: 49%;
  }
  svg {
    color: $contact_btn_icon;
    width: 24px;
    height: 24px;
    margin-right: 12px;
    transition: all 0.5s;
  }

  &:hover {
    background: $contact_btn_hover_bg;
    color: $contact_btn_hover_color;

    svg {
      color: $contact_btn_hover_icon;
    }
  }
   &::before {
    content: "";
    width: 40%;
    height: 100%;
    display: block;
    background: #fff;
    position: absolute;
    -webkit-transform: skewX(-20deg);
    transform: skewX(-20deg);
    left: -10%;
    opacity: 0;
    top: 0;
    z-index: 5;
    transition: all .4s cubic-bezier(.2,.95,.57,.99)
    }
    &:hover:before {
    opacity: 1;
    width: 90%;
    left: 140%
    }
}
.address {
  width: 600px;
  height: 60px;
  background: #fff;
  //box-shadow: $contact_btn_border;
}
.google-btn {
  width: 280px;
  height: 60px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  color: $contact_google_btn_color;
  background: $contact_google_btn_bg;
  background-position: center !important;
  box-shadow: $contact_btn_border;
  transition: all 0.5s;

  svg {
    color: $contact_google_btn_icon;
    width: 24px;
    height: 24px;
    margin-right: 12px;
    transition: all 0.5s;
  }

  &:hover {
    background: $contact_google_hover_btn_bg;
    color: $contact_google_hover_btn_color;

    svg {
      color: $contact_google_hover_btn_icon;
    }
  }
}

/* 平板尺寸 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .contact-info {
    display: flex;
    width: 90% !important;
    height: 460px;
    padding: 60px 0 80px;

    .logo {
      width: $contact_logo_tablet_width;
    }
  }
}

/* 手機尺寸 */
@media only screen and (max-width: 767px) {
  .contact-info {
    display: flex;
    width: 100%;
    height: auto;
    padding: 40px;
    transform: none;
  // position: static;
    margin: 0;

    .logo {
      width: $contact_logo_mobile_width;
    }
  }

  .btn {
    &.half {
      width: 280px;
    }
    svg{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left:  calc(50% - 5em);
      margin-right:0;
      + span{
        margin-left: 1.5em;
      }
    }
  }

  .info {
    width: 100%;
    justify-content: center;
    text-align: center;
    //margin-bottom: 40px;

    > * {
      margin-bottom: 12px;
      &.address{
      margin-bottom: 0;}
    }
  }

  .logo {
    margin-bottom: 20px;
    margin: 0 auto 30px;
    left: auto;
    position: relative;
  }

  .address {
    width: 280px;
    padding: 0 1em;
    text-align: justify;
  }
}

@media only screen and (max-width: 321px) {
  .address {
    font-size: 14px;
  }
}
</style>
